import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class RegionsService {
  fetchRegions = () => {
    return fetch(config.config.endpointUrls.fetchRegions(), {
      method: 'GET'
    })
  }
}

export default new RegionsService()



// WEBPACK FOOTER //
// ../src/services/regionsService/regionsService.js